<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/UfRm8H/tc-custom/9781467445481.jpg?1731055222582" alt="This image is the cover for the book Discovering Romans, Discovering Biblical Texts (DBT)"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Discovering Romans, Discovering Biblical Texts (DBT)
      </h1>
      <p class="bookDescription body article font2">
        <i>Concise, student-friendly introduction to Romans</i><br/><br/> This third volume in the Discovering Biblical Texts series offers readers a compact, up-to-date, and student-friendly introduction to Paul's letter to the Romans, focusing on its structure, content, theological concerns, key interpretive debates, and historical reception.<br/><br/> Anthony C. Thiselton alerts readers to key issues and questions raised by the text, encouraging in-depth study and a sincere grappling with the theological and historical questions raised by this often-controversial epistle. He pays special attention to the book's reception and its influence on Christian history and culture, exploring and explaining the approaches and conclusions of a wide range of ancient and modern interpreters.<br/>  
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Anthony C. Thiselton
      </h2>
      
      <p class="authorDescription body article"> &#160; <B>Anthony C. Thiselton</B>&#160;(1937&ndash;2023) was professor of Christian theology at the University of Nottingham, England. His many books include&#160;<I>A Shorter Guide to the Holy Spirit, Systematic Theology</I>, and&#160;<I>Life after Death: A New Approach to the Last Things.</I></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Society for Promoting Christian Knowledge
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?866a7740